module.exports = __webpack_public_path__ + "static/media/MUJ.cabf7179.png";